export const EXPIRE_CODE_SINGIN_OTHER_DEVICE = 'signin_other_device';
export const EXPIRE_CODE_PASSWORD_CHANGED = 'password_changed';
export const EXPIRE_CODE_ACCOUNT_DELETED = 'account_deleted';
export const EXPIRE_CODE_DEVICE_BLOCKED = 'device_blocked';
export const EXPIRE_CODE_NOT_WHITELISTED = 'not_whitelisted';
export const EXPIRE_CODE_LOGGED_OUT = 'logged_out';
export const EXPIRE_CODE_MOCK_TIMEOUT = 'mock_timeout';